module.exports = __webpack_public_path__ + "static/media/ink.d99c0d98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/img/ink.jpg
// module id = 124
// module chunks = 0